<template>
    <svg v-if="isActive" class="heading-icon" width="26" height="2" viewBox="0 0 26 2" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line y1="1" x2="26" y2="1" :stroke="activeColor" stroke-width="2" />
    </svg>
    <svg v-else class="heading-icon" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line y1="13" x2="26" y2="13" :stroke="lineColor" stroke-width="2" />
        <line x1="13" y1="26" x2="13" y2="4.37114e-08" :stroke="lineColor" stroke-width="2" />
    </svg>
</template>
<script>
export default {
    props: {
        theme: String,
        activeColor: {
            type: String,
            default: '#FF6900'
        },
        isActive: Boolean
    },
    computed: {
        lineColor() {
            return this.theme === 'dark' ? '#F7F7F7' : '#262626';
        }
    }
};
</script>
